import { getRouter as getRouterPackage } from '@online-webinar/router';
import { provideStoreRuntime } from '@online-webinar/store';
import { updateRoutes } from './updateRoutes';

export function getRouter() {
    const router = getRouterPackage();

    if (!import.meta.env.SSR) {
        // The store and its sagas live in the browser only; see provideStoreRuntime.
        provideStoreRuntime(router.options.context.runtime);
    }

    // Loop through all keys in updateRoutes and execute each value method
    Object.keys(updateRoutes).forEach((key) => {
        const updateMethod = updateRoutes[key as keyof typeof updateRoutes];
        updateMethod(router);
    });

    return router;
}
